import React from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'

import AuthWrapper from '~/components/authWrapper'
import RedirectNewUser from '~/components/redirectNewUser'

import Contracts from './pages/contracts'
import AddContract from './pages/addContract'
import Docusign from './pages/docusign'
import Users from './pages/users'
import NewUser from './pages/newuser'
import Templates from './pages/templates'
import EditTemplate from './pages/editTemplate'
import DocumentDetails from './pages/documentDetails'
import DocumentDashboard from './pages/dashboard/documentDashboard'
import DemandsDashboard from 'pages/dashboard/demandsDashboard'
import AddContractExternal from './pages/addContractExternal'
import Settings from './pages/settings'
import Companies from './pages/companies'
import Home from './pages/home'
import EditDocument from 'pages/editDocument'
import TextDatabases from 'pages/textDatabases'
import TextDatabaseDetails from 'pages/textDatabaseDetails'
import InternalDatabase from 'pages/internalDatabase'
import InternalDatabaseDetails from 'pages/internalDatabaseDetails'
import Demands from 'pages/demands'
import CreateDemand from 'pages/demandsCreate'
import DetailsDemands from 'pages/detailsDemands'
import EditDemand from 'pages/editDemand'
import DemandChat from 'pages/demandChat'
import SignInSSO from 'pages/signIn/components/signInSSO'
import Auth from 'pages/signIn'
import ForgotPassword from 'pages/signIn/components/ForgotPassword'
import ResetPassword from 'pages/signIn/components/ResetPassword'
import SignUp from 'pages/signIn/components/SignUp'
import AuthCallback from 'pages/signIn/AuthCallback'
import OnlyLegalRoute from 'components/OnlyLegalRoute'
import Reports from 'pages/reports'

export const ROUTES = {
	docusign: '/docusign-token',
	home: '/',
	dashboard: '/dashboard',
	documents: '/documents',
	form: '/documents/new',
	users: '/users',
	newuser: '/newuser',
	templates: '/models',
	newTemplate: '/models/new',
	editTemplate: '/models/edit',
	documentDetails: '/documents/:id',
	editDocumentDetails: '/documents/:id/edit',
	externalContract: '/documentcreate/:token',
	demands: '/demands',
	demandsCreate: '/demands/new',
	demandsEdit: '/demands/:id/edit',
	demandDetails: '/demands/:id',
	demandChat: '/demands/:id/chat',
	demandsDashboard: '/demands/dashboard',
	textDatabases: '/textdatabases',
	textDatabaseDetails: '/textdatabases/:id(\\d+)',
	internalDatabase: '/internaldatabases',
	internalDatabaseDetails: '/internaldatabases/:id(\\d+)',
	settings: '/settings',
	companies: '/companies',
	reports: '/reports',
	signIn: '/sign-in',
	signInSSO: '/sign-in/sso',
	forgotPassword: '/sign-in/forgot-password',
	resetPassword: '/sign-in/reset-password',
	signUp: '/sign-up',
	authCallback: '/auth/callback',
}

function Routes() {
	return (
		<Router>
			<Switch>
				{/* <Route path={ROUTES.signInSSO} component={SignInSSO} />
				<Route path={ROUTES.forgotPassword} component={ForgotPassword} />
				<Route path={ROUTES.resetPassword} component={ResetPassword} />
				<Route path={ROUTES.signUp} component={SignUp} /> */}
				<Route path={ROUTES.externalContract} component={AddContractExternal} />
				<Route path={ROUTES.authCallback} component={AuthCallback} />
				<Route path={ROUTES.docusign} component={Docusign} />
				{/* <Auth> */}
				<AuthWrapper>
					<Route exact path={ROUTES.home} component={Home} />
					<Route exact path={ROUTES.newuser} component={NewUser} />
					<RedirectNewUser>
						<Switch>
							<OnlyLegalRoute
								exact
								path={ROUTES.form}
								component={AddContract}
							/>
							<OnlyLegalRoute
								exact
								path={ROUTES.dashboard}
								component={DocumentDashboard}
							/>
							<Route exact path={ROUTES.demands} component={Demands} />
							<Route
								exact
								path={ROUTES.demandsCreate}
								component={CreateDemand}
							/>
							<Route exact path={ROUTES.demandsEdit} component={EditDemand} />
							<Route
								exact
								path={ROUTES.demandsDashboard}
								component={DemandsDashboard}
							/>
							<Route
								exact
								path={ROUTES.demandDetails}
								component={DetailsDemands}
							/>
							<Route exact path={ROUTES.demandChat} component={DemandChat} />
							<OnlyLegalRoute
								exact
								path={ROUTES.documents}
								component={Contracts}
							/>
							<OnlyLegalRoute
								exact
								path={ROUTES.templates}
								component={Templates}
							/>
							<OnlyLegalRoute
								exact
								path={ROUTES.newTemplate}
								component={EditTemplate}
							/>
							<OnlyLegalRoute
								exact
								path={ROUTES.editTemplate}
								component={EditTemplate}
							/>
							<OnlyLegalRoute exact path={ROUTES.users} component={Users} />
							<OnlyLegalRoute
								exact
								path={ROUTES.documentDetails}
								component={DocumentDetails}
							/>
							<OnlyLegalRoute
								exact
								path={ROUTES.editDocumentDetails}
								component={EditDocument}
							/>
							<OnlyLegalRoute
								exact
								path={ROUTES.textDatabases}
								component={TextDatabases}
							/>
							<OnlyLegalRoute
								exact
								path={ROUTES.textDatabaseDetails}
								component={TextDatabaseDetails}
							/>
							<OnlyLegalRoute
								exact
								path={ROUTES.internalDatabase}
								component={InternalDatabase}
							/>
							<OnlyLegalRoute
								exact
								path={ROUTES.internalDatabaseDetails}
								component={InternalDatabaseDetails}
							/>
							<OnlyLegalRoute
								exact
								path={ROUTES.companies}
								component={Companies}
								isPrivate
							/>
							<OnlyLegalRoute
								exact
								path={ROUTES.settings}
								component={Settings}
							/>
							<OnlyLegalRoute exact path={ROUTES.reports} component={Reports} />
						</Switch>
					</RedirectNewUser>
				</AuthWrapper>
				{/* </Auth> */}
			</Switch>
		</Router>
	)
}

export default Routes
